// removed by extract-text-webpack-plugin
module.exports = {"app":"_3sz-Jorbvi2LDO38TpQcMl","brand":"_u4avc-WstuZP5sdbqIV1","appContent":"gsYlqHuubB3bKiaXdybMG"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/App.scss
// module id = 1060
// module chunks = 0